// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-single-customer-search-field {
    border: none !important;
    background-color: #f9fafb !important;
}
.easycommerce .easycommerce-single-customer-search-field:focus,
.easycommerce .easycommerce-refund-input-field:focus {
    outline: none;
    box-shadow: none;
    border: none;
}
.easycommerce .easycommerce-refund-input-field {
    border: none !important;
    padding: 0 0 0 16px !important;
}
.easycommerce .easycommerce-refund-input-field::-webkit-outer-spin-button,
.easycommerce .easycommerce-refund-input-field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/css/customers.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;AACA;;IAEI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;AACA;;IAEI,wBAAwB;IACxB,qBAAqB;AACzB","sourcesContent":[".easycommerce .easycommerce-single-customer-search-field {\n    border: none !important;\n    background-color: #f9fafb !important;\n}\n.easycommerce .easycommerce-single-customer-search-field:focus,\n.easycommerce .easycommerce-refund-input-field:focus {\n    outline: none;\n    box-shadow: none;\n    border: none;\n}\n.easycommerce .easycommerce-refund-input-field {\n    border: none !important;\n    padding: 0 0 0 16px !important;\n}\n.easycommerce .easycommerce-refund-input-field::-webkit-outer-spin-button,\n.easycommerce .easycommerce-refund-input-field::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
